module.exports = __webpack_public_path__ + "img/bg_honor_desk_2.42243f1e.png";